// Dish Edit Flow Ids
export const FOOD_ITEM_TABLE = 'food-item-table';
export const ADD_NEW_DISH_BUTTON = 'add-new-dish-btn';
export const SCRATCH_DISH_BUTTON = 'scratch-dish-button';
export const TEMPLATE_DISH_BUTTON = 'template-dish-button';
export const WEEKLY_SHEF_SERVICE_DISH_BUTTON = 'weekly-shef-service-dish-button';
export const STEPPER_NEXT_BUTTON = 'stepper-next-button';
export const DISH_EDIT_TITLE_INPUT = 'dish-edit-title-input';
export const SPICE_LEVEL_OPTIONS_DROPDOWN = 'spice-level-options-dropdown';
export const SPICE_LEVEL_OPTIONS_ERROR = 'spice-level-options-error';
export const DISH_EDIT_GEO_TAGS = 'dish-edit-geo-tags';
export const DISH_EDIT_SPEC_TAGS = 'dish-edit-spec-tags';
export const BASE_SERVING_MODAL = 'base-serving-modal';
export const BASE_SERVING_SERVINGS_DROPDOWN = 'base-serving-servings-dropdown';
export const BASE_SERVING_PRICE_INPUT = 'base-serving-price-input';
export const BASE_SERVING_NEXT_BUTTON = 'base-serving-next-button';
export const PRICE_OUT_OF_RANGE_MODAL = 'price-out-of-range-modal';
export const PRICE_OUT_OF_RANGE_MODAL_CONTINUE = 'price-out-of-range-continue';
export const SERVING_SIZE_OPTION = 'serving-size-option';
export const SERVING_SIZE_OPTION_PORTION = 'serving-size-option-portion';
export const SERVING_SIZE_OPTION_PRICE = 'serving-size-option-price';
export const SERVING_SIZE_OPTION_SERVINGS = 'serving-size-option-servings';
export const ADD_SERVING_PLUS = 'add-serving-plus';
export const DELETE_SERVING_X = 'delete-serving-x';
export const DELETE_SERVING_CONFIRMATION = 'delete-serving-confirmation';
export const DISH_EDIT_DESCRIPTION_INPUT = 'dish-edit-description-input';
export const WEEKDAY_PICKER_SUN = 'weekday-picker-sun';
export const WEEKDAY_PICKER_MON = 'weekday-picker-mon';
export const WEEKDAY_PICKER_TUE = 'weekday-picker-tue';
export const WEEKDAY_PICKER_WED = 'weekday-picker-wed';
export const WEEKDAY_PICKER_THU = 'weekday-picker-thu';
export const WEEKDAY_PICKER_FRI = 'weekday-picker-fri';
export const WEEKDAY_PICKER_SAT = 'weekday-picker-sat';
export const DISH_EDIT_FIELD_ERROR = 'dish-edit-field-error';
export const DISH_EDIT_REHEATING_DROPDOWN = 'dish-edit-reheating-dropdown';
export const DISH_EDIT_PACKAGING_SELECTION = 'dish-edit-packaging-selection';
export const ALLERGEN_ACK_CHECKBOX = 'allergen-ack-checkbox';
export const DIETARY_ACK_CHECKBOX = 'dietary-ack-checkbox';
export const SUBMIT_DISH_BUTTON = 'submit-dish-button';
export const FOOD_ITEMS_EDIT_DISH_BUTTON = 'food-items-edit-dish-button';
export const FOOD_ITEM_FINDING = 'food-item-finding';
export const FOOD_ITEM_FINDING_DISMISS = 'food-item-finding-dismiss';
export const FOOD_ITEM_FINDING_AUTO_FIX = 'food-item-finding-auto-fix';
export const FOOD_ITEM_FINDING_SECONDARY_CTA = 'food-item-finding-secondary-cta';
